export default "__VITE_ASSET__D77xazEh__"